import React from 'react';

interface LogoIconWhiteProps {
    size?: number;
    [key: string]: any;
}

const LogoIconWhite: React.FC<LogoIconWhiteProps> = ({size = 23, ...props}) => (
    <svg
        width={size}
        height={size * 25.12 / 23}
        viewBox="0 0 338 369"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask id="mask0_311_6" style={{maskType: 'luminance'} as any} maskUnits="userSpaceOnUse" x="0" y="0" width="335" height="245">
            <path d="M0.11499 0H334.184V244.578H0.11499V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_311_6)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M231.314 192.608C232.871 192.095 234.738 191.583 237.103 190.934C251.12 187.083 280.287 179.07 304.23 153.426C318.047 138.627 328.035 120.178 334.184 98.2334C333.864 95.0404 333.651 93.2764 333.651 93.2764C333.651 93.2764 333.675 46.6404 292.22 24.3964C241.271 -2.40856 172.763 0.0594394 172.763 0.0594394C-1.86301 5.01444 11.406 72.7684 0.92099 193.691C0.54899 197.979 0.28999 202.114 0.11499 206.133C41.649 212.851 80.092 213.881 100.28 210.942C101.112 210.819 101.928 210.761 102.731 210.761C109.384 210.761 115.174 214.795 122.3 219.762C138.836 231.285 168.584 252.022 239.251 241.852C238.099 240.556 236.926 239.205 235.757 237.814C223.296 222.985 218.579 212.583 220.465 204.085C221.686 198.585 225.538 194.509 231.314 192.608Z"
                fill="white"
            />
        </g>
        <mask id="mask1_311_6" style={{maskType: 'luminance'} as any} maskUnits="userSpaceOnUse" x="0" y="140" width="338" height="229">
            <path d="M0 140.591H337.147V368.217H0V140.591Z" fill="white" />
        </mask>
        <g mask="url(#mask1_311_6)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M317.96 166.245C290.389 195.776 256.534 205.076 242.078 209.047C241.082 209.321 240.153 209.576 239.333 209.808C241.735 216.183 252.809 230.029 264.762 241.27L278.077 253.792L260.144 257.327C238.234 261.646 219.422 263.415 203.217 263.415C152.083 263.417 126.831 245.814 111.561 235.173C108.282 232.888 104.234 230.067 102.587 229.588C81.829 232.529 43.427 231.976 0 225.157C3.218 316.878 61.916 327.385 72.553 331.336C84.302 335.699 57.553 364.089 57.553 364.089C131.002 380.431 145.483 342.872 155.177 344.489C188.761 350.007 287.848 336.534 312.01 294.02C335.537 253.021 338.222 185.822 336.857 140.591C331.476 149.949 325.182 158.51 317.96 166.245Z"
                fill="white"
            />
        </g>
    </svg>
);

export default LogoIconWhite;
